/**
 * @param {number} length
 * @return {Array<number>}
 * */
export default function range(length) {
  return Array.from({ length }, (_, k) => k);
}
